import { Line, Rect } from "@-/com.npmjs.react-native-svg";
import type { GraphemeGlyphGuidePalette } from "@-/dev.improve.haniverse.routes.nav.app._components.morpheme.grapheme.glyph.svg.entities";
import { GRAPHEME_SVG_GLYPH_CELL_UNITS } from "#grapheme-svg-glyph-animation";

/**
 * Faint 田字格 practice guides: a thin frame and dotted center lines behind the ink.
 * Word strips share a sheet with thin dividers between characters.
 * Exception: the frame radius uses the same 1024-unit drawing coordinates as the handwriting.
 */
export function GraphemeSvgGlyphStripGuide({
  columnCount,
  guidePalette,
}: {
  columnCount: number;
  guidePalette: GraphemeGlyphGuidePalette;
}) {
  const stripWidth = GRAPHEME_SVG_GLYPH_CELL_UNITS * columnCount;
  const cellOffsetList = Array.from(
    { length: columnCount },
    (_, index) => index * GRAPHEME_SVG_GLYPH_CELL_UNITS,
  );
  return (
    <>
      <Rect
        fill={guidePalette.background}
        height={928}
        rx={20}
        stroke={guidePalette.frame}
        strokeWidth={6}
        width={stripWidth - 96}
        x={48}
        y={48}
      />
      <Line
        stroke={guidePalette.grid}
        strokeDasharray="16 20"
        strokeOpacity={guidePalette.gridOpacity}
        strokeWidth={4}
        x1={72}
        x2={stripWidth - 72}
        y1={512}
        y2={512}
      />
      {cellOffsetList.map((offset) => (
        <GraphemeSvgGlyphStripGuideCell
          guidePalette={guidePalette}
          hasDivider={offset > 0}
          key={offset}
          offset={offset}
        />
      ))}
    </>
  );
}

function GraphemeSvgGlyphStripGuideCell({
  guidePalette,
  hasDivider,
  offset,
}: {
  guidePalette: GraphemeGlyphGuidePalette;
  hasDivider: boolean;
  offset: number;
}) {
  return (
    <>
      {hasDivider && (
        <Line
          stroke={guidePalette.grid}
          strokeOpacity={guidePalette.gridOpacity}
          strokeWidth={4}
          x1={offset}
          x2={offset}
          y1={72}
          y2={952}
        />
      )}
      <Line
        stroke={guidePalette.grid}
        strokeDasharray="16 20"
        strokeOpacity={guidePalette.gridOpacity}
        strokeWidth={4}
        x1={offset + 512}
        x2={offset + 512}
        y1={72}
        y2={952}
      />
    </>
  );
}
